export default "__VITE_ASSET__DSOxD9WV__"